import { WorkflowTransitionEmailRecipient } from 'src/app/api/models';

export type DynamicRecipientKind = NonNullable<WorkflowTransitionEmailRecipient['to_dynamic']>[number];

export interface DynamicRecipientOption {
  value: DynamicRecipientKind;
  label: string;
}

// Referenti dell'entità che si possono aggiungere in automatico ad A, CC e BCC
// delle email di cambio stato (configurazione di stato e workflow)
export const DYNAMIC_RECIPIENT_OPTIONS: Record<'ticket' | 'delivery', DynamicRecipientOption[]> = {
  ticket: [{ value: 'TICKET_REFERENT', label: 'Referente ticket' }],
  delivery: [
    { value: 'DELIVERY_SHIPPING', label: 'Referente consegna (spedizione)' },
    { value: 'DELIVERY_MAINTENANCE', label: 'Referente tecnico (manutenzione)' },
    { value: 'DELIVERY_RAEE', label: 'Referente RAEE' },
    { value: 'DELIVERY_STAGING', label: 'Referente staging' },
  ],
};

export function dynamicRecipientLabel(kind: DynamicRecipientKind): string {
  return (
    [...DYNAMIC_RECIPIENT_OPTIONS.ticket, ...DYNAMIC_RECIPIENT_OPTIONS.delivery].find(
      o => o.value === kind
    )?.label ?? kind
  );
}
